"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PremiumIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const streamline_icon_mystery_svg_1 = __importDefault(require("@public/media/icons/streamline-icon-mystery.svg"));
const styled_components_1 = __importStar(require("styled-components"));
const polished_1 = require("polished");
const PremiumIcon = ({ shouldBeHiddenIfPremiumIsActive = true, width = 16, height = 16, isInCircle, className, color, hasActivePremiumSubscription, }) => {
    if (shouldBeHiddenIfPremiumIsActive && hasActivePremiumSubscription) {
        return null;
    }
    if (isInCircle) {
        return ((0, jsx_runtime_1.jsx)(CircleIconWrapper, { children: (0, jsx_runtime_1.jsx)(streamline_icon_mystery_svg_1.default, { width: width, height: height, className: className }) }));
    }
    return ((0, jsx_runtime_1.jsx)(IconWrapper, { color: color, children: (0, jsx_runtime_1.jsx)(streamline_icon_mystery_svg_1.default, { width: width, height: height, className: className }) }));
};
exports.PremiumIcon = PremiumIcon;
const CircleIconWrapper = styled_components_1.default.div `
	margin-left: 0.5rem;
	border-radius: 1rem;
	background: ${({ theme }) => (0, polished_1.transparentize)(0.8, theme.color.brand1)};
	width: 1.75rem;
	height: 1.75rem;
	max-width: 1.75rem;
	max-height: 1.75rem;
	min-width: 1.75rem;
	min-height: 1.75rem;
	display: flex;
	align-items: center;
	justify-content: center;
	svg {
		color: ${({ theme }) => theme.color.brand1};
	}
`;
const IconWrapper = styled_components_1.default.div `
	${({ color }) => color &&
    (0, styled_components_1.css) `
			color: ${color};
		`}
`;
